import { useEffect, useState } from "react";
import api from "@/lib/api";
import useSeo from "@/lib/useSeo";

export default function MediaCoverage() {
  const [items, setItems] = useState([]);
  useSeo({ title: "In the Media | Healthy Roots Holistics", description: "Healthy Roots in the news — featured coverage including the Hamilton Spectator." });
  useEffect(() => { api.get("/public/media-coverage").then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <div className="pt-28 pb-24" data-testid="media-page">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="text-sm uppercase tracking-widest text-emerald-700 font-semibold">Press & Features</span>
          <h1 className="text-4xl sm:text-5xl mt-2 text-emerald-950">In the Media</h1>
        </div>
        <div className="space-y-6">
          {items.map((m) => (
            <a key={m.id} href={m.url} target="_blank" rel="noopener noreferrer" className="group flex flex-col sm:flex-row gap-6 bg-white rounded-2xl p-6 border border-stone-200/80 hover:shadow-md transition-all">
              <img src={m.image} alt={m.outlet} loading="lazy" className="w-full sm:w-40 h-40 object-cover rounded-xl flex-shrink-0" onError={(e) => { e.target.style.display = "none"; }} />
              <div><span className="text-xs font-mono uppercase text-emerald-700">{m.outlet}</span><p className="font-serif text-xl text-emerald-900 mt-1 group-hover:text-emerald-700">{m.title}</p><span className="text-sm text-[#C85A32] font-semibold mt-3 inline-block">Read Article →</span></div>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
